import { mockable } from '@datadog/js-core/util'
import { reportScriptLoadingError } from '../domain/scriptLoadingError'
import type { createRumProfiler } from '../domain/profiling/datadogProfiler'

export async function lazyLoadProfiler(): Promise<typeof createRumProfiler | undefined> {
  try {
    return await mockable(importProfiler)()
  } catch (error: unknown) {
    reportScriptLoadingError({
      error,
      source: 'Profiler',
      scriptType: 'module',
    })
  }
}

export async function importProfiler() {
  const module = await import(/* webpackChunkName: "datadogProfiler" */ '../domain/profiling/datadogProfiler')
  return module.createRumProfiler
}
